export default __webpack_public_path__ + "static/media/about-1.dd9dc9b4.jpg";